
import { ItiBaseDto } from '@/iti-core-vue';
import { Guid } from 'guid-typescript';
import { CategoryThirdLevel } from './category-third-level';


export class CategoryFourthLevel extends ItiBaseDto {
    public code !: string;
    public description !: string;
    public categoryThirdLevel !: CategoryThirdLevel;
    public externalID!: Guid;
}